import { postCollectionFilter } from 'src/services/eLearning/collection'
import { startLoading, stopLoading } from 'src/redux/slices/loading'

export const filterCollection = (filter) => async (dispatch) => {
  dispatch(startLoading())
  await dispatch(postCollectionFilter(filter))
  dispatch(stopLoading())
}
